import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserContextService } from '../../services/service/user-context.service';
import { AppSwitcherService } from '../../services/service/app-switcher.service';
import { OfficeSwitcherService } from '../../services/service/office-switcher.service';

@Component({
  selector: 'zx-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {
  errorIconType: string;
  errorTitle: string;
  errorMessage: string;
  errorCode: Number;
  dark: boolean = false;
  isAuthenticated: boolean;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userContext: UserContextService,
    public appSwitcher: AppSwitcherService,
    public officeSwitcher: OfficeSwitcherService) { }

  ngOnInit() {
    this.isAuthenticated = this.userContext.isAuthenticated;
    this.activatedRoute.data.subscribe(routeData => {
      this.dark = routeData.dark;
      if (routeData.error403) this.errorCode = 403;
      else this.errorCode = routeData.errorCode;

      this.errorMessage = routeData.errorMessage;
      switch (this.errorCode) {
        case 403:
          this.errorIconType = "safety";
          this.errorTitle = this.errorTitle || "403";
          const office = this.officeSwitcher.currentOffice;
          const officeTypeText = this.officeSwitcher.currentOfficeLevelText;
          if (office && this.appSwitcher.currentApp) {
            this.errorMessage = this.errorMessage || ("您在当前" + officeTypeText + ' [ ' + office.name + " ] 没有此应用的访问权限，可以切换" + officeTypeText + "或切换到其它应用，如果有疑问请与管理员联系！");
          } else {
            this.errorMessage = this.errorMessage || "抱歉，您无权访问此应用或功能，如果有疑问请与管理员联系！";
          }
          break;

        case 404:
          this.errorIconType = "rocket";
          this.errorTitle = this.errorTitle || "404";
          this.errorMessage = this.errorMessage || "抱歉，您访问的页面不存在!";
          break;

        default:
          this.errorIconType = "exclamation";
          this.errorTitle = this.errorTitle || "500";
          this.errorMessage = this.errorMessage || "抱歉，您访问的页面出错啦！";
          break;
      }
    });
  }
  get currentOfficeTypeText() {
    return "切换机构";
    // const text = this.officeSwitcher.currentOfficeLevelText;
    // return text ? "切换" + text : null;
  }
  changeApp() {
    this.appSwitcher.openSelector();
  }
  changeOffice() {
    this.officeSwitcher.openSelector();
  }
  login() {
    this.router.navigate(["/login"]);
  }
  get homeRouter(): string {
    return this.router.url.startsWith("/apps/") ? "/apps" : "/home";
  }
}
